'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_java$002eutil$002e$002dCollections$0024$002dUnmodifiable$002dIterator from "./java.util.-Collections$-Unmodifiable-Iterator.js";
var $p;
/** @constructor */
function $c_ju_Collections$UnmodifiableListIterator(innerIterator) {
  this.vs = null;
  $j_java$002eutil$002e$002dCollections$0024$002dUnmodifiable$002dIterator.$ct_ju_Collections$UnmodifiableIterator__ju_Iterator__(this, innerIterator);
}
export { $c_ju_Collections$UnmodifiableListIterator as $c_ju_Collections$UnmodifiableListIterator };
$p = $c_ju_Collections$UnmodifiableListIterator.prototype = new $j_java$002eutil$002e$002dCollections$0024$002dUnmodifiable$002dIterator.$h_ju_Collections$UnmodifiableIterator();
$p.constructor = $c_ju_Collections$UnmodifiableListIterator;
/** @constructor */
function $h_ju_Collections$UnmodifiableListIterator() {
}
export { $h_ju_Collections$UnmodifiableListIterator as $h_ju_Collections$UnmodifiableListIterator };
$h_ju_Collections$UnmodifiableListIterator.prototype = $p;
var $d_ju_Collections$UnmodifiableListIterator = new $j_java$002elang$002e$002dObject.$TypeData().i($c_ju_Collections$UnmodifiableListIterator, "java.util.Collections$UnmodifiableListIterator", ({
  mY: 1,
  dO: 1,
  dP: 1,
  bd: 1,
  n2: 1,
  dS: 1
}));
export { $d_ju_Collections$UnmodifiableListIterator as $d_ju_Collections$UnmodifiableListIterator };
